(function() {
  'use strict';

  if (!window.customElements || customElements.get('herbertle-guarantee')) return;

  class HerbertleGuarantee extends HTMLElement {
    connectedCallback() {
      this.observeCart();
      if (this.initialized) return;
      var dialog = this.querySelector('dialog');
      if (!dialog || typeof dialog.showModal !== 'function') return;

      this.initialized = true;
      var trigger = this.querySelector('.legal-guarantee__trigger');
      var content = this.querySelector('[data-guarantee-content]');
      dialog.appendChild(content);
      trigger.setAttribute('aria-haspopup', 'dialog');

      var textView = this.querySelector('.legal-guarantee__text');
      var textTrigger = textView.querySelector('summary');
      textView.addEventListener('toggle', function() {
        textTrigger.textContent = textView.open ? 'Textansicht schließen' : 'Hinweis als Text lesen';
        if (!textView.open || !dialog.open) return;
        var toolbar = dialog.querySelector('.legal-guarantee__toolbar');
        dialog.scrollTo({
          top: dialog.scrollTop + textView.getBoundingClientRect().top -
            dialog.getBoundingClientRect().top - toolbar.offsetHeight - 16,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      });

      trigger.addEventListener('click', function(event) {
        event.preventDefault();
        if (!dialog.open) dialog.showModal();
      });
      this.querySelector('[data-guarantee-close]').addEventListener('click', function() {
        dialog.close();
      });
      var pointerStartedOutside = false;
      function outsideDialog(event) {
        var bounds = dialog.getBoundingClientRect();
        return event.clientX < bounds.left || event.clientX > bounds.right ||
          event.clientY < bounds.top || event.clientY > bounds.bottom;
      }
      dialog.addEventListener('pointerdown', function(event) {
        pointerStartedOutside = event.target === dialog && outsideDialog(event);
      });
      dialog.addEventListener('click', function(event) {
        if (pointerStartedOutside && event.target === dialog && outsideDialog(event)) dialog.close();
        pointerStartedOutside = false;
      });
      dialog.addEventListener('close', function() {
        trigger.focus();
      });
    }
    observeCart() {
      if (!this.hasAttribute('data-service-variants')) return;
      var form = this.closest('form');
      var lines = form && form.querySelector('[data-cart-line-items]');
      if (!lines) return;
      var serviceVariants = this.getAttribute('data-service-variants').split(',');
      var notice = this;
      function update() {
        notice.hidden = !Array.prototype.some.call(lines.querySelectorAll('[data-cart-item-key]'), function(line) {
          var variantId = line.getAttribute('data-cart-item-key').split(':')[0];
          return serviceVariants.indexOf(variantId) === -1;
        });
      }
      if (this.cartObserver) this.cartObserver.disconnect();
      this.cartObserver = new MutationObserver(update);
      this.cartObserver.observe(lines, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-cart-item-key'] });
      update();
    }

    disconnectedCallback() {
      if (this.cartObserver) this.cartObserver.disconnect();
    }
  }

  customElements.define('herbertle-guarantee', HerbertleGuarantee);
})();
